import { useQuery } from 'react-query';
import { getCompanyV2, getCompany } from '../api/company';

export const useCompany = ({ id, tenantId }, options = {}) => {
  const { useV2, ...queryOptions } = options;

  return useQuery(
    ['company', id, tenantId],
    () => (useV2 ? getCompanyV2(id, tenantId) : getCompany(id, tenantId)),
    queryOptions,
  );
};
